export var ENTITY = "note";
export var REDUCER_KEY = "NOTE_V2";
export var BASE_PATH_ENTITY = "notes";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
